(function () {
  var MOBILE_BREAKPOINT = 768;

  function isMobileViewport() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function getGalleryWraps() {
    return document.querySelectorAll('.gallery-wrap');
  }

  function removeDesktopGalleryOnMobile(galleryWrap) {
    var desktopGallery = galleryWrap.querySelector('.gallery_on_desktop');

    if (desktopGallery && isMobileViewport()) {
      desktopGallery.remove();
    }
  }

  function injectMobileGallery(galleryWrap) {
    var mount = galleryWrap.querySelector('[data-zh-mobile-gallery-mount]');
    var template = galleryWrap.querySelector('[data-zh-mobile-gallery-template]');

    if (!mount || !template || mount.dataset.zhMobileGalleryInjected === 'true') {
      return;
    }

    var fragment = template.content.cloneNode(true);
    mount.appendChild(fragment);
    mount.dataset.zhMobileGalleryInjected = 'true';

    var productGallery = mount.querySelector('[data-product-gallery]');

    if (
      productGallery &&
      window.jQuery &&
      window.productPage &&
      typeof window.productPage.enableGallery === 'function'
    ) {
      window.productPage.enableGallery(window.jQuery(productGallery));
    }
  }

  function setupResponsiveProductGallery() {
    getGalleryWraps().forEach(function (galleryWrap) {
      if (isMobileViewport()) {
        injectMobileGallery(galleryWrap);
        removeDesktopGalleryOnMobile(galleryWrap);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupResponsiveProductGallery);
  } else {
    setupResponsiveProductGallery();
  }

  window.addEventListener('resize', function () {
    setupResponsiveProductGallery();
  });
})();